<template>
  <section class="cart">
    <div class="container-c">
      <!-- <div class="header">
        <img :src="url('/media/icons/svg/cart1.svg')" alt="cart icon" />
        <span>Carrello</span>
        <span class="close" @click="closeCart">
          <img :src="url('/media/icons/svg/close.svg')" alt="close icon" />
        </span>
      </div> -->
      <div class="cart-body">
        <ch_cartCard
            v-if="currentUser"
          class="CartCard"
          v-for="(item, key) in cartItems"
          :cod_art="item.cod_art"
          :quantita="item.quantita"
          :prezzo="item.prezzo"
          :key="key"
          :chiave="key"
          @refreshImballo = "getCart"
          :currentUser="currentUser"
          @loaded="caricati"
          @refreshTotCarrello="calcolaTotCarrello"
          @disponibilita="emitDisponibilita"
        />
      </div>
<!--      <div class="imballi">-->
<!--        <imballi-->
<!--            v-for="(imballo, key) in imballi"-->
<!--            :imballi ='imballo'-->
<!--            :key="key"-->
<!--            :chiave="key"-->
<!--            @loaded="loaded"-->
<!--        />-->
<!--      </div>-->

    </div>
  </section>
</template>

<script>
import ch_cartCard from "./ch-cart-card";
import imballi from "./imballi-card"

export default {
  components: {
    ch_cartCard,
    imballi
  },
  data() {
    return {
      cartItems: null,
      totaleCarrello: 0,
      // currentUser: null,
      // currentRole: null,
      isLoaded: false,
      currentArticles: null,
      imballi: [],
      isReady: false,
      allLoaded: false,
    };
  },
  watch: {
    totaleCarrello: function () {
      this.$emit('totaleCarrello', this.totaleCarrello)
    },
    cartItems: function (){
      if (this.cartItems) {
        this.$emit('numArticoli', this.cartItems.length)
      } else {
        this.$emit('numArticoli', 0)
      }
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.nav.user.cod_cli_for
    },
    currentRole() {
      return this.$store.state.nav.user.id_ruolo
    }
  },
    mounted() {
    this.getCart();
    this.calcolaTotCarrello();
   // this.getCurrentUser()
  },

  methods: {
    emitDisponibilita: function (status) {
      if (!status){
        this.$emit('disponibilita', false)
      }

    },
    caricati: function (key) {
      if (key === this.cartItems.length - 1){
        this.$emit('loaded', this.cartItems)
      } else if (this.cartItems.length === 0){
        this.$emit('loaded', this.cartItems)
      }
    },
    mergeArticoliImballi: function () {
      let tmp =[]
      this.articoli.forEach((art, i)=>{
       if (this.imballi.find(element => element.codImballo === art.imballo)){
         let obj = {
           art: art.articolo,
           quantita: art.quantita
         }
         tmp.push(obj)
         let index = this.imballi.findIndex(element => element.codImballo === art.imballo)
         this.imballi[index] = {
           ...this.imballi[index],
           articoli: tmp
         }
       }
      })
    },
    loaded: function (value) {
      if (value === this.imballi.length -1) {
        //this.mergeArticoliImballi()
        //this.$emit('calcImballi', {imballi: this.imballi})
      }
    },
    calcImballi: function () {
      this.imballi = []
      this.articoli = []
      this.cartItems.forEach((el)=>{
        axios({
          method: 'get',
          url: window.location.origin + '/data/getArticleInfo',
          params: {
            codart: el.cod_art
          }
        })
            .then(res =>{

              this.currentArticles = res.data.data
              let cod_imballo = this.currentArticles.cod_imballo
              let quantita = el.quantita
              let qta_x_imballo = this.currentArticles.qta_per_imballo
              let pesoMetro = this.currentArticles.peso_metro
              let numImballi = quantita / qta_x_imballo
              // this.articoli.push({
              //   articolo: el.cod_art,
              //   quantita: el.quantita,
              //   imballo: cod_imballo,
              // })
              // if(this.imballi.find(x => x.codImballo === cod_imballo)) {
              //
              //   let index = this.imballi.findIndex(x => x.codImballo === cod_imballo)
              //   this.imballi[index].numImballi += numImballi
              // } else {
                this.imballi.push({
                  cod_art: el.cod_art,
                  quantita: el.quantita,
                  codImballo: cod_imballo,
                  numImballi: numImballi,
                })

              // }

            })
      })


    },
    getCurrentUser: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/data/get-current-user',

      })
          .then(res => {
            //console.log(res.data)
            this.currentUser = res.data.user
            this.currentRole = res.data.role
          })
          .catch(err => {


            this.$store.commit('add_message', {
              type: 'error',
              message: err.response.data.message
            })

          })
    },
    calcolaTotCarrello: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/cart",
        params: {
          action: "getTotCart",
        },
      }).then((result) => {
        this.totaleCarrello = result.data.total;
      });
    },
    closeCart: function () {
      this.$emit("onCloseCart", true);
    },
    getCart: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/cart",
        params: {
          action: "getCart",
        },
      })
        .then((result) => {
          this.cartItems = result.data.data;
          this.$emit("numberItems", this.cartItems.length);
          //this.calcImballi()
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.cart {
  margin-left: auto;
  width: 100%;

  background-color: #ffffff;

  .container-c {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .header {
      display: flex;
      align-items: center;
      padding: 23px 40px;
      border-bottom: 2px solid #d8d8d8;

      img {
        display: inline-block;
        width: 22px;
        filter: brightness(0);
        margin-right: 25px;
      }

      span {
        display: inline-block;
        font-size: 24px;
      }

      .close {
        margin-left: auto;
        cursor: pointer;

        img {
          width: 15px;
          filter: brightness(0);
        }
      }
    }

    .cart-body, .imballi {
      display: flex;
      flex-direction: column;
      align-items: center;
      //height: calc(100vh - 362px);
      overflow-y: auto;
      overflow-x: hidden;
      width: auto;
    }

    .totale {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      background-color: var(--black-2);
      color: #ffffff;
      margin-top: auto;
      padding: 37px 62px;
      height: 70px;

      .total-price {
        margin-left: auto;
      }
    }

    .checkout {
      a {
        border: none;
        padding: 37px 62px;
        width: 100%;
        height: 70px;
      }
    }
  }
}
</style>
